import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { rem } from '@mantine/core';
import { memo } from 'react';
import styled from 'styled-components';
import type { IHeaderProps } from './StrawberryTableHeader.types';

const Separator = styled.div<IHeaderProps>`
	border-right: ${rem(1)} solid var(--border-color);
	${({ height }) =>
		`height: ${height};
    `}
	width: ${rem(1)};
	position: absolute;
	left: -1rem;
	top: 0;
`;
const StrawberryTableHeader = ({
	content,
	height,
	index,
	hasFirstLeftVerticalLine,
}: IHeaderProps) => {
	return (
		<th>
			<Text variant="sans/14/600" disableVariantMapping>
				{content}
			</Text>
			{hasFirstLeftVerticalLine ? (
				<Separator height={height} />
			) : (
				index !== 0 && <Separator height={height} />
			)}
		</th>
	);
};
const _StrawberryTableHeaderExport = memo(StrawberryTableHeader);

export { _StrawberryTableHeaderExport as StrawberryTableHeader };
